import { gql } from "@apollo/client";
import { skipToken, useQuery, useSuspenseQuery } from "@apollo/client/react";

import Product from "./Product.graphql";
import ProductByBrandAndNaturalKey from "./ProductByBrandAndNaturalKey.graphql";
import { products } from "../../modules/api";

export function useSuspenseProduct(id: string, brandID: string, naturalKey: string) {
    return useSuspenseQuery(
        gql(id ? Product : ProductByBrandAndNaturalKey),
        (id || (brandID && naturalKey))
            ? {
                client: products,
                variables: id
                    ? {
                        id,
                    }
                    : {
                        brand: {
                            id: brandID,
                        },
                        naturalKey,
                    },
            }
            : skipToken,
    );
}

export default function useProduct(productID: string) {
    return useQuery(
        gql(Product),
        {
            client: products,
            skip: !productID,
            variables: {
                id: productID,
            },
        },
    );
}
